const styles = (theme) => ({
  /* sayfa iskeleti */
  root: {
    maxWidth: 1024,
    margin: '0 auto',
    padding: '20px 16px',
  },
  formGrid: {
    display: 'flex',
  },
  panel: {
    width: '100%',
    maxWidth: 520,         // iki paneli de makul tut
  },

  /* alanlar */
  textField: {
    width: '100%',
    marginBottom: 20,
    transform: 'none !important',
  },
  formControl: {
    width: '100%',         // ← sabit %33.95 kaldırıldı
  },
  select: {
    fontFamily: 'Gilroy',
    fontSize: 12,
    padding: '4%',
    backgroundColor: 'white !important',
    borderRadius: '28px !important',
    border: '1px solid rgba(0,0,0,0.25)',
    width: '58%',
    height: 57,
  },

  title: { fontSize: 24 },

  /* buton */
  cta: {
    display: 'inline-flex',
    marginLeft: 0,         // inline margin kaldır
    marginTop: 12,
  },

  /* mobil iyileştirme */
  [theme.breakpoints.down('sm')]: {
    root: { padding: '16px 12px' },
    formGrid: { justifyContent: 'center' },
    panel: { maxWidth: '100%' },
    cta: { width: '100%' }, // istersen tek satır genişliğinde
  },
});

export default styles;
